import { FILTER_SCOPE_TYPES } from 'constants/meetings'

import { useScope } from './use_scope'

export const useInScope = (name) => {
  const { scopeType } = useScope()

  return !!FILTER_SCOPE_TYPES[name].includes(scopeType)
}
